import React, { useState } from "react";
import "./Dictionary.css";
import axios from "axios";
import Results from "./Results";
import Photos from "./Photos";

export default function Dictionary() {
  let [searchWord, setSearchWord] = useState("sunset");
  let [definitionData, setdefinitionData] = useState(null);
  let [loaded, setLoaded] = useState(false);
  let [photo, setPhoto] = useState(null);

  function handleDictionaryResponse(response) {
    setdefinitionData(response.data[0]);
  }

  function handlePexelsResponse(response) {
    setPhoto(response.data.photos);
  }

  function searchWordChange(event) {
    setSearchWord(event.target.value);
  }

  function Search() {
    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${searchWord}`;
    axios.get(apiUrl).then(handleDictionaryResponse);

    let pexelsApiKey =
      "563492ad6f917000010000017ff82ec3f6e74fa6890d8a6fafe6f5dd";

    let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${searchWord}&per_page=9`;
    axios
      .get(pexelsApiUrl, {
        headers: { Authorization: `Bearer ${pexelsApiKey}` },
      })
      .then(handlePexelsResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    Search();
  }

  function load() {
    setLoaded(true);
    Search();
  }

  if (loaded) {
    return (
      <div className="Container">
        <div className="Dictionary-app">
          <form>
            <input
              className="input"
              type="search"
              onChange={searchWordChange}
              placeholder=" Suggestion: book, flowers, etc."
            />
            <input
              type="submit"
              onClick={handleSubmit}
              value=" Search a word! "
            />
          </form>
        </div>
        <Results results={definitionData} />
        <Photos photos={photo} />
      </div>
    );
  } else {
    load();
    return null;
  }
}
